var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "axios"], function (require, exports, axios_1) {
    "use strict";
    var _a;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.createClient = void 0;
    axios_1 = __importDefault(axios_1);
    var responseInterceptor = [
        function (response) {
            if (response.request.responseURL.includes("/backoffice/entrar")) {
                window.location.href = '/backoffice/entrar';
                return Promise.reject();
            }
            if (response.request.responseURL.includes("/erro/")) {
                window.location.href = response.request.responseURL;
                return Promise.reject();
            }
            return response;
        },
        function (error) { return Promise.reject(error); }
    ];
    var client = axios_1.default.create({
        baseURL: document.getElementsByTagName('base')[0].href,
    });
    (_a = client.interceptors.response).use.apply(_a, responseInterceptor);
    var createClient = function (baseUrl, withResponseInterceptor) {
        var _a;
        if (baseUrl === void 0) { baseUrl = ""; }
        if (withResponseInterceptor === void 0) { withResponseInterceptor = false; }
        var client = axios_1.default.create({
            baseURL: !baseUrl ? document.getElementsByTagName('base')[0].href : baseUrl
        });
        if (withResponseInterceptor)
            (_a = client.interceptors.response).use.apply(_a, responseInterceptor);
        return client;
    };
    exports.createClient = createClient;
    exports.default = client;
});
